import { render } from "./activeYear.vue?vue&type=template&id=09aa5d4a&scoped=true"
import script from "./activeYear.vue?vue&type=script&lang=js"
export * from "./activeYear.vue?vue&type=script&lang=js"

import "./activeYear.vue?vue&type=style&index=0&id=09aa5d4a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@https+++registry.npmmirror.com+vue-loader+-+vue-loader-17.4.2.tgz_vue@3.2.13_webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09aa5d4a"]])

export default __exports__